/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import axios from 'axios';

const hostUrl = "";

export default {

    signup: (provider) => {
        return axios.post(hostUrl + '/api/provider/signup', provider)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getApprovalStatus: () => {
        return axios.get(hostUrl + '/api/provider/approvalStatus')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // check if provider ID is available 
    isProviderIDAvailable: (providerUniqueId) => {
        return axios.get(hostUrl + '/api/provider/isProviderIDAvailable', { params: { providerUniqueId } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // invite a client 
    sendInvite: (data) => {
        return axios.post(hostUrl + '/api/provider/sendInvite', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // invite multiple clients
    sendMultipleInvite: (data) => {
        return axios.post(hostUrl + '/api/provider/sendMultipleInvite', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },


    // send custom emails to multiple clients
    sendCustomEmail: (data) => {
        return axios.post(hostUrl + '/api/provider/sendCustomEmail', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    // Get client's form response
    getClientFormResponse: (id) => {
        return axios.get(hostUrl + '/api/provider/clientFormResponse', { params: { client: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // verify mobile
    sendOtpVerifyMobile: (type, phone) => {
        return axios.post(hostUrl + '/api/user/sendtophone', { type, phone })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get provider profile
    getProviderProfile: () => {
        return axios.get(hostUrl + '/api/provider/profile')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Update provider profile
    setProviderProfile: (provider) => {
        return axios.post(hostUrl + '/api/provider/profile', { provider })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // create payment link
    createPaymentLink: (options) => {
        return axios.post(hostUrl + '/api/payment/sendPaymentLink', options)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // resend payment link
    reSendPaymentLink: (options) => {
        return axios.post(hostUrl + '/api/payment/reSendPaymentLink', options)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // bookSession
    bookSession: (sessionDetails, paymentDetails, extraVoucher) => {
        return axios.post(hostUrl + '/api/provider/booksession', { sessionDetails, paymentDetails, extraVoucher })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get provider details for provider's booksession page
    getProviderDetails: () => {
        return axios.get(hostUrl + '/api/provider/providerDetails')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get list of pricings
    getPricings: () => {
        return axios.get(hostUrl + '/api/provider/pricing')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // set the pricings of the provider services
    setPricings: (pricing) => {
        return axios.post(hostUrl + '/api/provider/pricing', pricing)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get the list of settings of the provider
    getSettings: () => {
        return axios.get(hostUrl + '/api/provider/settings')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // set settings of the provider
    setSettings: (settings) => {
        return axios.post(hostUrl + '/api/provider/settings', settings)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get the list of clients of the provider
    getClients: () => {
        return axios.get(hostUrl + '/api/provider/clients')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get available timings of the provider
    getAvailableTimings: () => {
        return axios.get(hostUrl + '/api/provider/availableTimings')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // set available timings of the provider
    setAvailableTimings: (availableTimings) => {
        return axios.post(hostUrl + '/api/provider/availableTimings', { availableTimings })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get availableDaysAndBookings of provider
    getAvailableDaysAndBookings: () => {
        return axios.get(hostUrl + '/api/provider/availableDaysAndBookings')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // update the availabe day status of the provider
    setAvailableDayAndSlots: (updatedSlots) => {
        return axios.post(hostUrl + '/api/provider/availableDayAndSlots', { updatedSlots })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get provider profile image
    getProviderProfileImageAndEmail: () => {
        return axios.get(hostUrl + '/api/provider/profileImageAndEmail')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // Get list of sessions
    getSessions: () => {
        return axios.get(hostUrl + '/api/provider/sessions')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // set session notes
    setNotes: (data) => {
        return axios.post(hostUrl + '/api/provider/sessionNotes', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // request rescheduling of sessions on a particular date
    setSessionCompleted: (id) => {
        return axios.post(hostUrl + '/api/provider/setSessionCompleted', { id })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // cancel session
    cancelSession: (session) => {
        return axios.post(hostUrl + '/api/provider/cancelSession', { session })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // request rescheduling of sessions on a particular date
    requestRescheduling: (sessions) => {
        return axios.post(hostUrl + '/api/provider/requestRescheduling', { sessions })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },


    // get the payment summmary for the provider
    paymentSummary: () => {
        return axios.get(hostUrl + '/api/provider/payments')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    paymentDetail: (id) => {
        return axios.get(hostUrl + '/api/provider/paymentDetails', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    // get conversation list of provider
    getConversations: () => {
        return axios.get(hostUrl + '/api/provider/conversations')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            })
    },

    //conversation notes
    getConversationNote: (id) => {
        return axios.get(hostUrl + '/api/provider/conversationNotes', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    addConversationNote: (id, messageId, content) => {
        return axios.post(hostUrl + '/api/provider/conversationNotes', { id, messageId, content })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    editConversationNote: (id, noteId, messageId, content) => {
        return axios.post(hostUrl + '/api/provider/conversationNotes', { id, noteId, messageId, content })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getClientSubscriptions: (limit, page, query, isActive) => {
        return axios.get(hostUrl + '/api/provider/clientSubscriptions', { params: { limit: limit, page: page, name: query, isActive: isActive } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getClientSubscription: (clientId, subscriptionId) => {
        return axios.get(hostUrl + '/api/provider/clientSubscription', { params: { clientId: clientId, subscriptionId: subscriptionId } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    createClientSubscriptionPlan: (/*planId, */name, call, video, report, amount) => {
        return axios.post(hostUrl + '/api/provider/client/subscriptionPlan', { /*planId,*/ name, call, video, report, amount })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateClientSubscriptionPlan: (id/*, planId*/, name, call, video, report, amount) => {
        return axios.put(hostUrl + '/api/provider/client/subscriptionPlan', { id/*, planId*/, name, call, video, report, amount })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    deleteClientSubscriptionPlan: (id) => {
        return axios.delete(hostUrl + '/api/provider/client/subscriptionPlan', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getClientSubscriptionPlan: () => {
        return axios.get(hostUrl + '/api/provider/client/subscriptionPlan')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getClientSubscriptionPlans: () => {
        return axios.get(hostUrl + '/api/provider/client/subscriptionPlans')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    postRazorpayProviderSubscription: (razorpaySubscriptionPlanId, razorpaySubscriptionNotes) => {
        return axios.post(hostUrl + '/api/provider/razorpay/subscription', { razorpaySubscriptionPlanId, razorpaySubscriptionNotes })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    postProviderSubscription: (providerSubscriptionPlanId, razorpaySubscriptionId) => {
        return axios.post(hostUrl + '/api/provider/subscription', { providerSubscriptionPlanId, razorpaySubscriptionId })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    updateProviderSubscription: (razorpaySubscriptionId, providerSubscriptionPlan) => {
        return axios.put(hostUrl + '/api/provider/subscription', { razorpaySubscriptionId, providerSubscriptionPlan })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    cancelProviderSubscription: (razorpaySubscriptionId) => {
        return axios.delete(hostUrl + '/api/provider/subscription', { data: { razorpaySubscriptionId } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getActiveProviderSubsription: () => {
        return axios.get(hostUrl + '/api/provider/subscription/active')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getProviderSubcriptions: () => {
        return axios.get(hostUrl + '/api/provider/subscriptions')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getProviderSubscriptionPlan: (id) => {
        return axios.get(hostUrl + '/api/provider/subscriptionPlan', { params: { id: id } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    getProviderSubscriptionPlans: () => {
        return axios.get(hostUrl + '/api/provider/subscriptionPlans')
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // get list of coupons
    getCoupons: (limit, page, description, from, to) => {
        return axios.get(hostUrl + '/api/provider/coupons', { params: { limit, page, description, from, to } })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

    // add coupon
    addCoupons: (data) => {
        return axios.post(hostUrl + '/api/provider/addCoupon', data)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                throw err.response.data;
            });
    },

}